export default () => {
  const style = getComputedStyle(document.body)
  return {
    primary: style.getPropertyValue('--color-primary'),
    secondary: style.getPropertyValue('--color-secondary')
  }
}
